import { State } from '@progress/kendo-data-query';
import { toODataString } from '@progress/kendo-data-query/dist/npm/odata.operators';
import { ODataResponse } from '../types/oDataResponse';
import { get } from './Api';
import { Cart, CartDetail } from '../types/customerCartList';
import { CustomerShowAttendance } from 'src/types/customerShowAttendance';
import { ShowAttendee } from 'src/types/showAttendee';
import { FilterOption } from 'src/types/filterOption';
import { ShowSystemLogin } from 'src/types/showSystemLogin';

async function getCustomerCartSummary(filter: State): Promise<ODataResponse<Cart>> {
  return get<ODataResponse<Cart>>(`/odata/customerCart?${toODataString(filter, { utcDates: false })}&$count=true`);
}

async function getCustomerCartDetail(filter: State): Promise<ODataResponse<CartDetail>> {
  return get<ODataResponse<CartDetail>>(`/odata/customerCartDetail?${toODataString(filter, { utcDates: false })}&$count=true`);
}

async function getCustomerShowAttendance(filter: State): Promise<ODataResponse<CustomerShowAttendance>> {
  return get<ODataResponse<CustomerShowAttendance>>(`/odata/customerShowAttendance?${toODataString(filter, { utcDates: false })}&$count=true`);
}

async function getCustomerShowAttendees(filter: State): Promise<ODataResponse<ShowAttendee>> {
  return get<ODataResponse<ShowAttendee>>(`/odata/showAttendee?${toODataString(filter, { utcDates: false })}&$count=true`);
}

async function getAllActiveShows(): Promise<FilterOption[]> {
  return get<FilterOption[]>('/show/active');
}

async function createLogin(customer: string): Promise<ShowSystemLogin> {
  return get<ShowSystemLogin>(`/show/login/customer/${customer}`);
}

export default {
  getCustomerCartSummary,
  getCustomerCartDetail,
  getCustomerShowAttendance,
  getAllActiveShows,
  createLogin,
  getCustomerShowAttendees,
};
